import { render, staticRenderFns } from "./PptHeader.vue?vue&type=template&id=2ded1874&"
import script from "./PptHeader.vue?vue&type=script&lang=js&"
export * from "./PptHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ded1874')) {
      api.createRecord('2ded1874', component.options)
    } else {
      api.reload('2ded1874', component.options)
    }
    module.hot.accept("./PptHeader.vue?vue&type=template&id=2ded1874&", function () {
      api.rerender('2ded1874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/PptHeader.vue"
export default component.exports